import React from 'react';
import './index.scss';

class OpenNoticeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  render() {
    return (
			<div className="openNoticeDialog">
				<div className="dialog">
					<div className="close"></div>
					<div className="step">未到领取时间，开启通知提醒及时领取</div>
					<div className="openBtn">立即开启</div>
				</div>
			</div>
    );
  }
}

export default OpenNoticeDialog;
